export const NAVBAR_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    background_color: "#ffffff",
    hamburger_icon: "",
    hamburger_icon_alt: "",
    mobile_logo_icon: "",
    mobile_logo_icon_alt: "",
    status: true,
  },

  NAVBAR_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "show_hamburger",
      label: "Show Hamburger Menu on Mobile",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show the hamburger icon on the mobile bar (hides the drawer when off)",
      defaultValue: true,
    },
    {
      fieldName: "hamburger_icon",
      label: "Hamburger Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload hamburger menu icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "hamburger_icon_alt",
      label: "Hamburger Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for hamburger icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_logo_icon",
      label: "Mobile Logo Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile logo icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_logo_icon_alt",
      label: "Mobile Logo Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for mobile logo icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable navbar",
      defaultValue: true,
    },
  ],
};

export const MENU_ITEM_CONSTANTS = {
  DEFAULT_ROW: {
    id: "",
    parent_id: null,
    title: "",
    slug: "",
    url: "",
    status: true, // Changed from is_active
    priority: 1, // Changed from order_index
    text_color: "#000000", // Default black color
    is_button: false, // Added
    button_color: "#BE2330", // Default red color for button
  },

  MENU_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter menu title (e.g., MBA)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "parent_id",
      label: "Parent Menu",
      value: null,
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select parent menu",
      required: false,
      defaultValue: null,
      options: [], // Will be populated dynamically
    },
    {
      fieldName: "slug",
      label: "Slug",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Auto-generated from title",
      // required: true,
      defaultValue: "",
    },
    {
      fieldName: "url",
      label: "URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/programmes/mba (optional)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "priority", // Changed from order_index
      label: "Priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display priority",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status", // Changed from is_active
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable menu item",
      defaultValue: true,
    },
    {
      fieldName: "text_color", // Added
      label: "Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "is_button", // Added
      label: "Is Button",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Display as button",
      defaultValue: false,
    },
    {
      fieldName: "button_color", // Added
      label: "Button Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
  ],

  // Tree configuration for hierarchical widgets
  TREE_CONFIG: {
    // Tree display settings
    treeTitle: "Menu Structure",
    treeIcon: "🌳",
    emptyMessage: "No menu items yet. Add your first one below.",

    // Item display configuration
    itemDisplayFields: {
      primary: "title", // Main field to display
      secondary: "slug", // Secondary field (shown after primary)
      statusField: "status", // Changed from is_active
      statusInactiveLabel: "Inactive",
      childrenField: "children", // Field name for nested children
    },

    // Field mappings for tree operations
    fieldMappings: {
      id: "id",
      parentId: "parent_id",
      orderIndex: "priority", // Changed from order_index
      title: "title",
      slug: "slug",
      url: "url",
      isActive: "status", // Changed from is_active
    },

    // Parent dropdown configuration
    parentFieldName: "parent_id", // Field name that will have parent options
    parentTopLevelValue: "null", // Value for top-level items
    parentTopLevelLabel: "-- Top Level --",

    // Form labels
    formLabels: {
      addNew: "➕ Add New Menu Item",
      edit: "✏️ Edit Menu Item",
      saveButton: "Add Menu Item",
      updateButton: "Update Menu Item",
      newButton: "New",
      cancelButton: "Cancel",
    },

    // Delete confirmation
    deleteConfirmation: (item: any) =>
      `Delete "${item.title}"? This will also delete all child items.`,

    // Parent component requirement (for widgets that need a parent to be created first)
    requiresParentComponent: true,
    parentComponentName: "Navbar",
    parentIdFieldName: "navbar_id", // Field name for parent ID in child items
    childItemsFieldName: "menuItems", // Field name for child items in API response
    parentComponentTitle: "Navbar Settings",
    parentComponentSaveButtonText: "Save Navbar Settings",
    parentComponentCreateSuccessMessage: "Navbar created successfully",
    parentComponentUpdateSuccessMessage: "Navbar settings saved successfully",
    requireParentMessage:
      "Please save the Navbar Settings first before creating menu items. The navbar must be created before you can add menu items.",
    parentComponentMessage: {
      title: "Navbar Not Created Yet",
      description:
        "Please save the Navbar Settings above before adding menu items.",
    },
  },
};
